/**
 * Anzeige des Buchungscodes, gruppiert wie im Backend (core/codes/TicketCodec.ts):
 * `ABCDE-FGHJK-MNPQR-STUVW`. Unter dem QR-Code steht er im Klartext, als Rückfall,
 * wenn ein Scanner streikt (StyleGuide, QR-Fläche).
 */
export function formatBookingCode(code: string): string {
  return (code.match(/.{1,5}/g) ?? []).join("-");
}
